import { observer } from "mobx-react";
import * as React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router";
import styled, { createGlobalStyle } from "styled-components";

import DashboardPage from "@client/components/containers/DashboardPage";
import PartnerDetailsPage from "@client/components/containers/PartnerDetailsPage";
import PartnersPage from "@client/components/containers/PartnersPage";
import Tooltip from "@client/components/ui/Tooltip";
import licensorStore from "@client/stores/LicensorStore";
import { isLocationAvailable } from "@client/utils/Constants";

import CustomerDetailsPage from "./containers/CustomerDetailsPage/CustomerDetailsPage";
import CustomersPage from "./containers/CustomersPage/CustomersPage";
import LicenceDetailsPage from "./containers/LicenceDetailsPage/LicenceDetailsPage";
import LicencesPage from "./containers/LicencesPage/LicencesPage";
import LicensorDetailsPage from "./containers/LicensorDetailsPage/LicensorDetailsPage";
import UsersPage from "./containers/LicensorsPage/LicensorsPage";
import LoginPage from "./containers/LoginPage/LoginPage";
import NotFoundPage from "./containers/NotFoundPage/NotFoundPage";
import Notifications from "./ui/Notifications/Notifications";

const GlobalStyle = createGlobalStyle`
  html, body, main {
    height: 100%;
  }
  body {
    margin: 0;
    font-size: 14px;
    font-family: Rubik;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;
const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

@observer
class App extends React.Component {
  componentDidMount() {
    licensorStore.loadTokenInfo();
  }

  render() {
    return (
      <Wrapper>
        <Router basename={env.BASENAME}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/licences" element={<LicencesPage />} />
            <Route path="/licences/:id" element={<LicenceDetailsPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/customers/:id" element={<CustomerDetailsPage />} />
            {isLocationAvailable?.("/licensors", licensorStore?.tokenInfo) && (
              <Route path="/licensors" element={<UsersPage />} />
            )}
            {isLocationAvailable?.("/licensors", licensorStore?.tokenInfo) && (
              <Route path="/licensors/:id" element={<LicensorDetailsPage />} />
            )}
            {isLocationAvailable?.("/partners", licensorStore?.tokenInfo) && (
              <Route path="/partners" element={<PartnersPage />} />
            )}
            {isLocationAvailable?.("/partners", licensorStore?.tokenInfo) && (
              <Route path="/partners/:id" element={<PartnerDetailsPage />} />
            )}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
        <Notifications />
        <Tooltip />
        <GlobalStyle />
      </Wrapper>
    );
  }
}

export default App;
